<script>
export default
{
    name: 'mv-program-import-form',

    props:
    {
        model: Object,
        edit: Boolean,
        errors: null,
    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },

        fileChanged(e)
        {
            if (e && e.target && e.target.files)
            {
                this.model.xlsx = e.target.files
            }
        },
    },

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form" enctype="multipart/form-data">
        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('PROGRAM.FILE') }}
            </label>
            <div class="col-md-6">
                <input type="file" class="form-control" @change="fileChanged" required>
            </div>
        </div>
    </form>
    <div class="container" v-if="errors">
        <div class="row alert alert-danger" v-for="(error, index) in errors" :key="index">
            <label>
                {{ $t('ERROR.LINE_NR', { line: error.line } )}}
            </label>
            <div v-for="(msg, index) in error.messages" class="text-warning" :key="index">
                {{ $t('ERROR.' + msg.toUpperCase()) }}
            </div>
        </div>
        <div class="text-center">
            <button class="btn btn-warning" @click="$emit('close')">{{ $t('GENERAL.OK') }}</button>
        </div>
    </div>
</div>
</template>


// WEBPACK FOOTER //
// src/components/forms/ProgramImportForm.vue